"use client";

import { useVotingStore } from "@/store/voting";
import { VotingCardType } from "@/lib/election-helpers";
import { AccountCard } from "@/components/my-account/AccountCard";

interface ElectionCardRendererProps {
  initialVotingCardType: VotingCardType;
  electionId?: number | null;
}

export default function ElectionCardRenderer({ 
  initialVotingCardType, 
  electionId 
}: ElectionCardRendererProps) {
  const { hasVotedInElection } = useVotingStore();
  
  // Business logic: Override server-provided voting card type if user has voted 
  // in the specific election. This handles the case where user just voted and the 
  // server hasn't been updated yet, ensuring immediate UI feedback for the specific election.
  const hasVotedInThisElection = electionId ? hasVotedInElection(electionId) : false;
  const finalVotingCardType = hasVotedInThisElection ? "already-voted" : initialVotingCardType;

  const renderVotingCard = (cardType: VotingCardType) => {
    switch (cardType) {
      case "not-member":
        return (
          <AccountCard
            theme="dark"
            title="WORD LID"
            description={["Word lid van de partij door het registratieformulier in te vullen."]}
            buttonText="LID WORDEN"
            href="/lid-worden"
          />
        );
      case "no-elections":
        return (
          <AccountCard
            theme="dark"
            title="VERKIEZINGEN"
            description={["Er zijn momenteel geen actieve verkiezingen."]}
          />
        );
      case "already-voted":
        return (
          <AccountCard
            theme="dark"
            title="BEDANKT"
            description={["Bedankt voor uw stem! U heeft gestemd in alle beschikbare verkiezingen."]}
          />
        );
      case "can-vote":
        return (
          <AccountCard
            theme="dark"
            title="Ondersteuningsverklaringen"
            description={["Geef een ondersteuningsverklaring aan een motie of wijzigingsvoorstel. Let op: dit is nog géén stem."]}
            buttonText="Verder"
            href="/mijn-account/stemmen"
          />
        );
      default:
        return null;
    }
  };

  return renderVotingCard(finalVotingCardType);
}